module.exports = __webpack_public_path__ + "images/5c4b3f117c0dbb7b3624eb77713dd70e.svg";